import React from 'react';
import { useCurrentModule } from '@wix/package-picker-shared-eclipse';

export const MONEY_BACK_LABEL_KEY =
  'premium-purchase-plan.plans.cta.money_back';

export const useMoneyBackLabelViewed = (isEnabled: boolean) => {
  const { internals } = useCurrentModule();
  const hasReported = React.useRef(false);

  const onLabelViewed = React.useCallback(() => {
    if (hasReported.current) {
      return;
    }
    hasReported.current = true;
    internals.bi.onFeatureTooltipHover?.({ featureKey: MONEY_BACK_LABEL_KEY });
  }, [internals.bi]);

  return isEnabled
    ? {
        onMouseEnter: onLabelViewed,
        onFocus: onLabelViewed,
        onShowTooltip: onLabelViewed,
      }
    : {};
};
